module.exports = "<button mat-icon-button\n        class=\"viega-icon-button\"\n        [color]=\"matTheme\"\n        [style.background]=\"background\"\n        tabindex=\"-1\">\n\n    <span class=\"icon\" [ngClass]=\"'icon-' + icon\">\n        <ng-content></ng-content>\n    </span>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/viega-common/components/viega-icon-button/viega-icon-button.component.html
// module id = X8dz
// module chunks = 5